<div class="container">
    <div class="row mb-5">
        <div class="col-lg-7 col-md-6 col-sm-6 pt-4">
            <div class="text-start mb-3">
                <div class="h6 text-uppercase"><b>Gelişmiş Entegratör</b></div>
                <div class="h2"><span>Tüm Entegrasyonlar Tek Bir Platformda</span></div>
            </div>
            <div class="h4 mb-2">Pazaryerleri, Kargo, Muhasebe ve Daha Fazlası, Tek Panelde</div>
            <p>Entegratör yazılımımız sayesinde, tüm işletme süreçlerinizi tek bir platform üzerinden yönetebilirsiniz.
                Pazaryerleri, kargo takip sistemleri ve muhasebe yazılımları gibi farklı sistemleri entegre ederek, her
                şeyin uyum içinde çalışmasını sağlıyoruz.
            </p>
            <div class="py-4 d-flex">
                <a [routerLink]="'/iletisim'" class="btn btn-dark me-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 48 48">
                        <rect width="48" height="48" fill="none" />
                        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                            d="M19.308 12.467a24 24 0 0 1-.881-4.384C18.27 6.602 16.977 5.5 15.488 5.5H8.58c-1.777 0-3.145 1.535-2.989 3.304c1.575 17.829 15.777 32.03 33.606 33.606c1.77.156 3.304-1.207 3.304-2.984v-6.16c0-2.248-1.102-3.536-2.583-3.693a24 24 0 0 1-4.384-.88a4.9 4.9 0 0 0-4.87 1.243l-2.957 2.957a31.27 31.27 0 0 1-12.599-12.599l2.957-2.957a4.9 4.9 0 0 0 1.244-4.87m4.053 24.77l4.344-4.344m-16.943-8.255l4.344-4.344"
                            stroke-width="1" />
                    </svg>
                    Detaylı Bilgi Alın</a>
                <a href="https://calendly.com/dotcrea/" target="_blank" class="btn btn-success">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 48 48">
                        <rect width="48" height="48" fill="none" />
                        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                            d="M41.05 12.6c1.63-1.3 2.85-.23 2.85 1.14v20.52c0 1.73-1.22 2.44-2.85 1.14L26.79 24ZM14 8v32M4.9 17.16h21.89v13.68H4.9m0-13.68L14 8h18.5a3.2 3.2 0 0 1 2.85 2.85v26.26A3.2 3.2 0 0 1 32.5 40H7.75a2.81 2.81 0 0 1-2.85-2.89Z"
                            stroke-width="1" />
                    </svg>
                    Meet Planlayın</a>
            </div>
        </div>

        <div class="col-lg-5 col-md-6 col-sm-6">
            <div class="bg-white text-center rounded p-0">
                <img src="../../../../../assets/img/dashb.webp" alt="entegrasyon" width="600" height="400"
                    class="border rounded shadow-sm">
            </div>
        </div>

    </div>

    <div class="row mb-5">
        <div class="col-lg-4 col-md-4 col-sm-6 mb-4">
            <div class="single-featured-services-box">
                <div class="h5"><b>Entegrasyon Kurulumu</b></div>
                <p>Amazon, eBay ve Etsy gibi dünya çapında popüler pazaryerlerini Shopify mağazanıza entegre ederek
                    ürünlerinizi milyonlarca potansiyel müşteriye ulaştırıyoruz.</p>
            </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 mb-4">
            <div class="single-featured-services-box">
                <div class="h5"><b>Otomatik Senkronizasyon</b></div>
                <p>Ürün, stok ve fiyat bilgilerinizi tüm platformlar arasında otomatik olarak senkronize ederek zaman
                    kazandırıyor ve hata riskini ortadan kaldırıyoruz.
                </p>
            </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 mb-4">
            <div class="single-featured-services-box">
                <div class="h5"><b>Merkezi Yönetim</b></div>
                <p>Tüm pazaryeri satışlarınızı ve siparişlerinizi tek bir panelden yöneterek operasyonel verimliliğinizi
                    artırıyoruz.</p>
            </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 mb-4">
            <div class="single-featured-services-box">
                <div class="h5"><b>Toplu Ürün Aktarımı</b></div>
                <p>Trendyol, Hepsiburada, N11 ve ÇiçekSepeti gibi Türkiye’nin önde gelen pazaryerlerine ürünlerinizi
                    otomatik olarak aktarıyoruz.

                </p>
            </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 mb-4">
            <div class="single-featured-services-box">
                <div class="h5"><b>Sipariş Yönetimi</b></div>
                <p>Tüm pazaryerlerinden gelen siparişleri Entegratör panelinize entegre ederek tek noktadan yönetim
                    kolaylığı sağlıyoruz.
                </p>
            </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 mb-4">
            <div class="single-featured-services-box">
                <div class="h5"><b>Fatura Entegrasyonu</b></div>
                <p>E-fatura, e-arşiv sistemleri ve muhasebe programlarıyla entegrasyon kurarak yasal süreçlerinizi
                    sorunsuz hale getiriyoruz.
                </p>
            </div>
        </div>


    </div>





</div>